/**
 * Debug Tab - JSON output for debugging
 */

interface DebugTabProps {
  project: any
  updatesData?: any
  channelsData?: any
  buildsData?: any
  logsData?: any
}

export function DebugTab({ project, updatesData, channelsData, buildsData, logsData }: DebugTabProps) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-2">Project</h3>
        <pre className="bg-secondary text-secondary-foreground p-4 rounded-lg overflow-x-auto text-xs">
          {JSON.stringify(project, null, 2)}
        </pre>
      </div>

      {updatesData && (
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-2">Updates Data</h3>
          <pre className="bg-secondary text-secondary-foreground p-4 rounded-lg overflow-x-auto text-xs">
            {JSON.stringify(updatesData, null, 2)}
          </pre>
        </div>
      )}

      {channelsData && (
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-2">Channels Data</h3>
          <pre className="bg-secondary text-secondary-foreground p-4 rounded-lg overflow-x-auto text-xs">
            {JSON.stringify(channelsData, null, 2)}
          </pre>
        </div>
      )}

      {buildsData && (
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-2">Builds Data</h3>
          <pre className="bg-secondary text-secondary-foreground p-4 rounded-lg overflow-x-auto text-xs">
            {JSON.stringify(buildsData, null, 2)}
          </pre>
        </div>
      )}

      {logsData && (
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-2">Logs Data</h3>
          <pre className="bg-secondary text-secondary-foreground p-4 rounded-lg overflow-x-auto text-xs">
            {JSON.stringify(logsData, null, 2)}
          </pre>
        </div>
      )}
    </div>
  )
}
